import { useFilterDashboardContext } from "./filter-dashboard.context";

export function FilterDashboard() {
  const {
    dateFilterElement,
    startDateFilterElement,
    endDateFilterElement,
    clearFiltersElement,
  } = useFilterDashboardContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {/* {dateFilterElement} */}
      {startDateFilterElement}
      {endDateFilterElement}
      {clearFiltersElement}
    </div>
  );
}
